import React, { useState } from "react";
import { EditOutlined, UndoOutlined, SaveOutlined, CloseOutlined } from "@ant-design/icons";
import { SbButton } from "uiCore";
import { SizedInputNumberStyled } from "../orgDesign.styles";
import { BarStyled, CardStyled, NumStyled, LabelStyled, EditingRowStyled } from "./OrgDesignBudgetBar.styles";

const formatUsd = (value) => `$${Math.round(value).toLocaleString()}`;

const OrgDesignBudgetBar = ({ baselineBudget, targetBudget, projectedBudget, onSetTargetBudget, syncing }) => {
  const [editing, setEditing] = useState(false);
  const [draftValue, setDraftValue] = useState(Math.round(targetBudget ?? baselineBudget));

  const effectiveTarget = targetBudget ?? baselineBudget;
  const overBudget = projectedBudget > effectiveTarget;

  const startEditing = () => {
    setDraftValue(Math.round(effectiveTarget));
    setEditing(true);
  };
  const commit = () => {
    if (draftValue == null || Number.isNaN(draftValue)) return;
    setEditing(false);
    onSetTargetBudget(draftValue);
  };
  const cancel = () => setEditing(false);

  return (
    <BarStyled>
      <CardStyled>
        <NumStyled>{formatUsd(baselineBudget)}</NumStyled>
        <LabelStyled>Baseline Budget</LabelStyled>
      </CardStyled>

      <CardStyled>
        {editing ? (
          <EditingRowStyled>
            <SizedInputNumberStyled
              $width={120}
              size="small"
              min={0}
              step={10000}
              value={draftValue}
              onChange={setDraftValue}
              onPressEnter={commit}
              formatter={(value) => `$${Math.round(value).toLocaleString()}`}
              parser={(value) => value.replace(/[$,]/g, "")}
              autoFocus
            />
            <SbButton buttonType="action" size="small" icon={<SaveOutlined />} title="Save" onClick={commit} disabled={draftValue == null || Number.isNaN(draftValue)} />
            <SbButton buttonType="action" size="small" icon={<CloseOutlined />} title="Cancel" onClick={cancel} />
          </EditingRowStyled>
        ) : (
          <NumStyled>
            {formatUsd(effectiveTarget)}
            <SbButton buttonType="action" size="small" icon={<EditOutlined />} title="Edit target budget" onClick={startEditing} />
            {targetBudget != null && (
              <SbButton buttonType="action" size="small" icon={<UndoOutlined />} title="Reset to baseline" onClick={() => onSetTargetBudget(null)} />
            )}
          </NumStyled>
        )}
        <LabelStyled>Target Budget{targetBudget == null ? " (= baseline)" : ""}</LabelStyled>
      </CardStyled>

      <CardStyled $bg={overBudget ? "#fef2f2" : "#f0fdf4"}>
        {/* Blank instead of the stale local number while a server sync is
            in flight, to avoid a flicker right before the real figure lands. */}
        <NumStyled $color={overBudget ? "#dc2626" : "#16a34a"}>{syncing ? "" : formatUsd(projectedBudget)}</NumStyled>
        <LabelStyled>Projected Budget{syncing ? " · Syncing…" : ""}</LabelStyled>
      </CardStyled>
    </BarStyled>
  );
};

export default OrgDesignBudgetBar;
